// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAKwy-nDhYOO7RnOVD4kGDJlowzUjWg4jo",
  authDomain: "abaya-12404.firebaseapp.com",
  projectId: "abaya-12404",
  storageBucket: "abaya-12404.firebasestorage.app",
  messagingSenderId: "349168846736",
  appId: "1:349168846736:web:383332af2a7e0472de5515",
  measurementId: "G-KRGQXNSE34"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { app, analytics, db, storage, auth };

